(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bg-system"] && !Shopify.designMode) return;
  try {
    (() => {
  const motion = () => {
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.animate([{opacity:.35,transform:'translateY(18px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,easing:'cubic-bezier(.2,.7,.2,1)'});
      observer.unobserve(entry.target);
    }),{threshold:.12});
    document.querySelectorAll('[data-bg-reveal]:not([data-bg-ready])').forEach(el => {el.dataset.bgReady='true';observer.observe(el);});
  };
  motion();document.addEventListener('shopify:section:load',motion);
  const bar=document.querySelector('[data-bg-sticky]');
  const form=document.querySelector('.product-form__submit');
  if(bar && form && 'IntersectionObserver' in window){
    const observer=new IntersectionObserver(entries => {const e=entries[0];bar.hidden=e.isIntersecting || e.boundingClientRect.top>0;},{threshold:0});
    observer.observe(form);
    bar.querySelector('a').addEventListener('click',()=>{setTimeout(()=>form.focus({preventScroll:true}),450);});
  }
})();
  } catch(e) { console.error(e); }
})();

})();
